import {VehicleLogFilterTypeEnum} from '@/enums/vehicle-log-filter-type.enum';

export function vehicleLogSortingTypeIconFilter(type: VehicleLogFilterTypeEnum) {
  switch (type) {
    case VehicleLogFilterTypeEnum.InWorkshop: return 'mdi-hammer-wrench';
    case VehicleLogFilterTypeEnum.Theft: return 'mdi-circle-off-outline';
    case VehicleLogFilterTypeEnum.NotPaid: return 'mdi-cash-remove';
    case VehicleLogFilterTypeEnum.NotRentedReadyToWork: return 'mdi-check';
    case VehicleLogFilterTypeEnum.RentedAndPaid: return 'mdi-cash-check';
    case VehicleLogFilterTypeEnum.PrePaymentRent: return 'mdi-calendar-range';
    default: return '';
  }
}
